var dd = require('react-dd');
var _ = require('lodash');
var esUtils = require('../utils/esUtils');

module.exports = dd.createClass({
	render: function(){
		var percent = this.props.percent;
		var custom_text = this.props.custom_text;
		var text_color = this.props.text_color || (percent > 0.5 ? 'white' : 'black');

		if(percent < 0 || percent > 1){
			//indeterminate progress if out of range
			return dd.div({className: 'progress progress-striped active'},
				dd.div({className: 'progress-bar', role: 'progressbar', style: {width: '100%'}})
			);
		}
		return dd.div({className: 'progress relative'},
			dd.div({className: 'text-center', style: {position: 'absolute', width: '100%', fontWeight: 'bold', color: text_color}},
				custom_text || (esUtils.format_number(percent * 100, 1) + '%')
			),
			dd.div({className: 'progress-bar', role: 'progressbar', style: {width: esUtils.format_number(percent * 100, 2) + '%'}})
		);
	}
});



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/ProgressBar.js
// module id = 181
// module chunks = 0 1 2 3 4